import Script from "src/component/script/Script";
import UIManifest from "src/engine/ui/UIManifest";
import { IInfo } from "src/component/props/PropsGGEditor/exec/ExecScript";
import ThirdShareCore from "./ThirdShareCore";
// import PropsUtils from "src/engineEditor/props/utils/PropsUtils";

type IShareType = "qq" | "weibo" | "qzone" | "baidu";

interface IThirdShareScript {
    type: IShareType;
    defaultUrl?: string;
    defaultTile?: string;
    defaultPic?: string;
    defaultDesc?: string;
    ismob?: boolean;
    mobMsg?: string;
}

/**
 * @class ThirdShareScript
 */
@UIManifest.declare("ThirdShareScript", "第三方分享脚本", UIManifest.Type.Script)
export default class ThirdShareScript extends Script<IThirdShareScript> {
    exec(info: IInfo) {
        const { type, defaultUrl, defaultTile, defaultPic, defaultDesc, ismob = false, mobMsg = "分享链接已复制，快去分享给你的好友吧" } = this.props;
        const { value } = info;
        if (!type || type === void 0) return false;
        const title = value.title || defaultTile || document.title;
        const url = value.url || defaultUrl || window.location.href;
        const pic = value.pic || defaultPic || "";
        const mate = document.querySelector('meta[name="description"]');
        const desc = value.desc || defaultDesc || (mate ? mate.getAttribute("content") : "");

        const map = { type, url, title, pic, desc, ismob, mobMsg };

        ThirdShareCore(map);

        return true;
    }
}
